import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CollabMergeResult, ConflictResolutionResult } from '@common/collab/models/collab-merge-result.model';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';

export interface CollabConflictResolutionDialogData {
  action?: string;
  branchName: string;
  conflictResolutionResult: ConflictResolutionResult;
  licenseId: number;
  projectId: number;
  title?: string;
}

@Component({
  selector: 'mc-collab-conflict-resolution-dialog',
  templateUrl: './collab-conflict-resolution-dialog.component.html',
  styleUrls: ['./collab-conflict-resolution-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollabConflictResolutionDialogComponent extends DialogBase<CollabConflictResolutionDialogComponent> implements OnInit {
  static DialogConfig: MatDialogConfig = {
    width: '52rem'
  };

  failedMerges: CollabMergeResult[];
  successfulMerges: CollabMergeResult[];

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: CollabConflictResolutionDialogData,
    protected dialogRef: MatDialogRef<CollabConflictResolutionDialogComponent>
  ) {
    super(dialog, dialogRef);

    this.failedMerges = this.data.conflictResolutionResult?.merged?.filter(item => !item.success);
    this.successfulMerges = this.data.conflictResolutionResult?.merged?.filter(item => item.success);
  }
}
